import { render, staticRenderFns } from "./TerminView.vue?vue&type=template&id=678f367e&scoped=true"
import script from "./TerminView.vue?vue&type=script&lang=js"
export * from "./TerminView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678f367e",
  null
  
)

export default component.exports